<template>
  <div class="item-container iflex">
    <div class="avatar-container">
      <img class="item-avatar" :src="item.avatar" />
      <img
        class="icon_header_v"
        src="@/static/ic_v_log.png"
        v-if="item.isAuthor"
      />
    </div>
    <div class="right-continer iflex">
      <div class="S8 T1 title-container iflex">
        {{ item.nickname }}
        <span class="item-owner C5 S2 B_C6" v-if="showOwner"> 楼主 </span>
      </div>
      <div class="S8 item-comment" :class="item.isAuthor ? 'C9' : 'T1'">
        {{ item.content }}
        <span v-if="item.parentComent">
          <span class="T1"> // </span>
          <span class="C5">{{ '@' + item.parentComent.nickname + ':' }}</span>
          <span :class="item.parentComent.isAuthor ? 'C9' : 'T1'">{{
            item.parentComent.content
          }}</span>
        </span>
      </div>
      <div class="timer-container iflex" @click="onReplyEvent(item)">
        <div class="S4 T3">
          {{ item.createTime }}
        </div>
        <div class="item-replay iflex S4 T1">
          回复
        </div>
      </div>

      <div
        class="delete-container iflex"
        v-if="canDelete"
        @click.stop="onDeleteEvent(item)"
      >
        <div class="btn-delete S2 T1">删除</div>
      </div>
      <div
        class="reply-container T3 relative"
        v-if="showReplyCount && item.replyCount > 0"
        @click="onReplyEvent(item, true)"
      >
        <div
          class="reply-item T6 S7"
          v-for="(subComment, index) in item.subComments"
          :key="index"
        >
          <span class="T3 left">{{ subComment.nickname }}：</span
          >{{ subComment.content }}
        </div>
        <div class="S4 C5" v-if="item.replyCount > 2">
          查看全部{{ item.replyCount }}条回复
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import status from '@/api/appInfo'
import dayjs from 'dayjs'

export default {
  name: 'comment-item',

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },

    showReplyCount: {
      type: Boolean,
      default: false
    },

    showDelete: {
      type: Boolean,
      default: true
    },

    showOwner: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    canDelete() {
      return status.appInfoResp.uid == this.item.userId && this.showDelete
    }
  },

  methods: {
    dayjs,
    onReplyEvent(item, isShowAll) {
      this.$emit('onShowAllEvent', isShowAll)
      this.$emit('onReplyEvent', item)
    },
    onDeleteEvent(item) {
      Dialog.confirm({
        title: '提示',
        message: '确定删除这条评论吗？',
        confirmButtonColor: '#046bcc',
        cancelButtonColor: '#999'
      })
        .then(() => {
          this.$emit('onDeleteEvent', item)
        })
        .catch(() => {
          console.log('你点击了confirm的取消')
        })
    }
  },

  mounted() {}
}
</script>

<style scoped lang="scss">
.item-container {
  position: relative;
  padding-top: 40px;
}
.list-container:last-child .item-container {
  padding-bottom: 40px;
}
.iflex {
  display: flex;
}
.avatar-container {
  height: 71px;
  width: 71px;
  position: relative;
  margin-left: 30px;
}

.item-avatar {
  height: 71px;
  width: 71px;
  border-radius: 35px;
}

.icon_header_v {
  width: 26px;
  height: 26px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.right-continer {
  flex-direction: column;
  margin-left: 20px;
  position: relative;
  width: 100%;
}

.title-container {
  align-items: center;
}

.item-comment {
  margin-top: 12px;
}

.item-owner {
  padding: 5px;
  background-color: #e8f0fa;
  border-radius: 5px;
  margin-left: 5px;
  height: 20px;
  line-height: 20px;
}

.timer-container {
  margin-top: 12px;
}

.item-replay {
  height: 34px;
  line-height: 34px;
  border-radius: 17px;
  margin-left: 20px;
  background-color: #e9e9e9;
  padding: 0 12px;
}

.delete-container {
  position: absolute;
  top: 0;
  right: 10px;
  width: 100px;
  height: 60px;
  align-items: center;
  justify-content: center;
}

.btn-delete {
  border: 1px solid #262626;
  border-radius: 15px;
  text-align: center;
  width: 60px;
}
.reply-container {
  border-radius: 16px;
  padding: 24px;
  background: rgba(133, 133, 133, 0.1);
  margin-right: 31px;
  margin-top: 20px;
}
.reply-item {
  margin-bottom: 24px;
  .left {
    float: left;
  }
}
</style>
